import Head from 'next/head';
import { infoEmail } from '@/constants/emails';
import { SITE_URL } from '@/lib/seoRoutes';

const policySections = [
  {
    type: 'header',
    html: `
<h1><strong>Copyright Policy</strong></h1>
    `,
  },
  {
    type: 'content',
    html: `
<p>This copyright policy applies to our website at <a
                        href="${SITE_URL}">www.docmoonlight.com</a> and/or our iOS and Android Mobile
                    applications
                    (collectively our “Platform”) operated by DOC Moonlight LLC of 160 W Camino Real #1009, Boca Raton,
                    FL 33432, United
                    States (“we,” “us,” “our,” “Docmoonlight”).
                </p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><strong>Intellectual Property</strong></h3>
                <p>All Content included on the Platform, unless uploaded by Users, including, but not limited to, text,
                    graphics, logos,
                    icons, images, sound clips, video clips, data compilations, page layout, underlying code and
                    software is the property of
                    Docmoonlight, our affiliates or other relevant third parties.</p>
                <p>By continuing to use the Platform you acknowledge that such material is protected by applicable
                    United States and
                    International intellectual property and other relevant laws.</p>

                <p>You may not reproduce, copy, distribute, store or in any other fashion re-use material from the
                    Platform unless
                    otherwise indicated on the Platform or unless given express written permission to do so by
                    Docmoonlight.</p>

                <p>You acknowledge that all intellectual property rights in our Platform anywhere in the world belong to
                    us, that rights
                    in our Platform are licensed (not sold) to you, and that you have no rights in, or to, our Platform
                    other than the
                    right to use them in accordance with these Terms.</p>

                <p>Any intellectual property rights in content uploaded by you to our Platform shall continue to belong
                    to you or their
                    respective owners. You agree that you grant us a royalty-free and non-exclusive license to use,
                    reproduce, publish
                    and display such intellectual property rights for the purposes of performing the Services,
                    promotional purposes,
                    internal administrative purposes and any other purposes set out in these Terms, including for the
                    purpose of
                    improving the Services and our responses to users of the Platform.</p>

                <p>You acknowledge that you have no right to have access to our Platform in source code form.</p>

                <p>You must not modify the paper or digital copies of any materials you have printed off or downloaded
                    from our Platform
                    in any way, and you must not use any illustrations, photographs, video or audio sequences or any
                    graphics separately
                    from any accompanying text.</p>

                <p>You must not use any part of the content on our Platform for commercial purposes not specified on our
                    Platform
                    without obtaining a license to do so from us or our licensors.</p>

                <p>If you print off, copy or download any content on our Platform in breach of this Policy, your right
                    to use our
                    Platform will cease immediately, and you must, at our option, return or destroy any copies of the
                    materials you have
                    made.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><strong>Use of Copyright</strong></h3>
                <p>For purposes of this Policy, references to copyright or marks include all trade and images and logos
                    owned by
                    Docmoonlight. DOC Moonlight’s copyright, images and logos represent intellectual property rights
                    owned by
                    Docmoonlight and as such are valued assets of Docmoonlight.</p>

                <p>Any licensed use by you of a Docmoonlight copyright must be authorized by us and requires proper
                    acknowledgement and
                    strict compliance with our requirements. Requests for a copyright license may be submitted to us
                    using
                    ${infoEmail}.</p>

                <p>By using any Docmoonlight copyright, you are acknowledging that Docmoonlight is the sole owner of the
                    copyright and
                    agreeing not to interfere with Docmoonlight’s rights in the copyright, including challenging our
                    use, registration
                    of, or application to register such copyright.</p>

                <p>You agree that you will not harm, misuse, or bring into disrepute any Docmoonlight copyright and that
                    the goodwill,
                    if any, derived from your use of any Docmoonlight copyright exclusively inures to the benefit of and
                    belongs to us.
                </p>

                <p>You may not use any Docmoonlight copyright in meta-tags, search fields, hidden text, or any other
                    form that has the
                    purpose or effect of diverting or confusing consumers without our prior written permission.</p>

                <p>Other product names or copyrights, including those appearing on Docmoonlight’s Platform, that are not
                    owned by us are
                    for identification purposes only and may be the registered or unregistered copyright of their
                    respective owners. No
                    license or right is granted by us by implication, estoppel or otherwise to any such third-party
                    names or copyright
                    or to the DOC Moonlight copyright hereby.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><strong>DMCA Notification</strong></h3>
                <p>We take the intellectual property rights of others seriously and are asking our users and visitors to
                    do the same.
                    Docmoonlight prides itself on being in full compliance with 17 U.S.C.512 and the Digital Millennium
                    Copyright Act
                    (DMCA) and other copyright and intellectual property protection laws.</p>

                <p>If you own a copyright or if you are officially acting on behalf of a copyright owner and want to
                    report a claim that
                    a copyright is infringed on or through our website, please send us a notice outlining the following
                    to the email
                    address below.</p>

                <ul>
                    <li>A description of the copyrighted work that you claim is being infringed;</li>
                    <li>A link or the URL or other location of the material you claim is infringing;</li>
                    <li>Your name, address, telephone number, and email address;</li>
                    <li>An electronic or physical signature of the owner of the copyright or a person authorized to act
                        on the owner's
                        behalf.</li>
                </ul>

                <p>Please also include the following statements:</p>

                <ul>
                    <li>“I have a good faith belief that the use of the copyrighted material I am complaining about is
                        not
                        authorized by the
                        copyright owner, its agent, or the law”</li>
                    <li>“The information in this notice is accurate and, under penalty of perjury, I am the owner, or
                        authorized to act on
                        behalf of the owner, of the copyright or of an exclusive right that is allegedly infringed”</li>

                </ul>
                <p>Our Email address for DMCA Notices is <a
                        href="mailto:${infoEmail}">${infoEmail}</a>.</p>

                <p><strong>
                        Please note the following:
                    </strong></p>
                <p>We are regularly monitoring this email inbox and will be reviewing your submission within 24 hours
                    and notify you of the
                    outcome or in some cases request further details. This typically includes the time it takes to
                    action your request and
                    to remove infringing content.
                </p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><strong>Counter Notification</strong></h3>
                <p>If you believe your own copyrighted material has been removed from the Site as a result of a mistake
                    or
                    misidentification, you may submit a written counter notification to us using the contact information
                    provided below
                    (a “Counter Notification”).</p>

                <p>To be an effective Counter Notification under the DMCA, your Counter Notification must include
                    substantially the
                    following:</p>
                <ul>
                    <li>Identification of the material that has been removed or disabled and the location at which the
                        material appeared
                        before it was removed or disabled;</li>
                    <li>A statement that you consent to the jurisdiction of the Courts in which your address is located,
                        or if your
                        address is outside the USA, for any judicial district in which we are located;</li>
                    <li>A statement that you will accept service of process from the party that filed the Notification
                        or the party's
                        agent;</li>
                    <li>Your name, address, and telephone number;</li>
                    <li>A statement under penalty of perjury that you have a good faith belief that the material in
                        question was removed
                        or disabled as a result of a mistake or misidentification of the material to be removed or
                        disabled;</li>
                    <li>Your physical or electronic signature.</li>
                </ul>

                <p>If you send us a valid, written Counter Notification meeting the requirements described above, we
                    will restore
                    removed or disabled material, unless we first receive notice from the party filing the Notification
                    informing us
                    that such party has filed a court action to restrain you from engaging in infringing activity
                    related to the
                    material in question.</p>

                <p>Please note that if you materially misrepresent that the disabled or removed content was removed by
                    mistake or
                    misidentification, you may be liable for damages, including costs and attorney's fees. Filing a
                    false Counter
                    Notification constitutes perjury.</p>
    `,
  },
  {
    type: 'content-section',
    html: `
<h3><strong>Validity and questions</strong></h3>
                <p>Copyright Policy was last updated on Thursday, January 26, 2023, and is the current and valid
                    version. However, we point
                    out that from time to time due to actual or legal changes a revision to this policy may be
                    necessary. If you have any
                    questions, please feel free to contact us.
                </p>
    `,
  },
];

const getSectionClassName = (type) => {
  if (type === 'header') return 'policy-header';
  if (type === 'content') return 'policy-content';
  return 'policy-section';
};

function CopyRights() {
  return (
    <>
      <Head>
        <title>Copyright Policy | DocMoonlight</title>
        <meta
          key='description'
          name='description'
          content='Read the DocMoonlight copyright policy.'
        />
        <meta key='robots' name='robots' content='noindex, follow' />
      </Head>

      <main className='min-h-screen bg-[radial-gradient(circle_at_top_left,rgba(var(--theme-accent-rgb),0.16),transparent_28%),linear-gradient(180deg,var(--theme-page-start)_0%,var(--theme-page-mid)_44%,var(--theme-page-end)_100%)] px-4 py-12 text-[var(--theme-dark)] sm:px-6 lg:px-8'>
        <article className='copyright-policy-content mx-auto max-w-5xl overflow-hidden rounded-[1.75rem] border border-[var(--theme-shadow)] bg-[var(--theme-paper)] p-6 shadow-[0_28px_90px_rgba(20,33,61,0.12)] md:p-10 lg:p-14'>
          {policySections.map((section, index) => (
            <section
              key={'copyrights-section-' + index}
              className={getSectionClassName(section.type)}
              dangerouslySetInnerHTML={{ __html: section.html }}
            />
          ))}
        </article>
      </main>

      <style jsx global>{`
        .copyright-policy-content {
          color: var(--theme-dark);
        }

        .copyright-policy-content .policy-header {
          margin-bottom: 2.5rem;
          text-align: left;
        }

        .copyright-policy-content .policy-header h1 {
          margin: 0;
          color: var(--theme-dark);
          font-family: inherit;
          font-size: clamp(2.4rem, 5vw, 4.2rem);
          font-weight: 900;
          letter-spacing: 0;
          line-height: 0.98;
        }

        .copyright-policy-content .policy-content,
        .copyright-policy-content .policy-section {
          margin: 0 0 2.1rem;
          color: var(--theme-dark);
          line-height: 1.7;
          text-align: left;
        }

        .copyright-policy-content .policy-section:last-child {
          margin-bottom: 0;
        }

        .copyright-policy-content h3,
        .copyright-policy-content h4 {
          margin: 2rem 0 0.9rem;
          color: var(--theme-dark);
          font-family: inherit;
          font-size: 1.35rem;
          font-weight: 900;
          line-height: 1.25;
        }

        .copyright-policy-content h4 {
          font-size: 1.12rem;
        }

        .copyright-policy-content p,
        .copyright-policy-content li {
          color: rgba(var(--theme-dark-rgb), 0.78);
          font-family: inherit;
          font-size: 1rem;
          font-weight: 600;
          line-height: 1.8;
        }

        .copyright-policy-content p {
          margin: 0 0 1rem;
        }

        .copyright-policy-content ul,
        .copyright-policy-content ol {
          margin: 0.7rem 0 1.2rem 1.5rem;
          padding: 0;
        }

        .copyright-policy-content li {
          margin-bottom: 0.55rem;
        }

        .copyright-policy-content a {
          color: var(--theme-accent);
          font-family: inherit;
          font-size: inherit;
          font-weight: 900;
          text-decoration: underline;
          text-decoration-thickness: 2px;
          text-underline-offset: 3px;
        }
`}</style>
    </>
  );
}

export default CopyRights;
